import { forwardRef, type ReactNode, type Ref } from 'react';
import { Text, type TextProps } from '../Text/Text.js';

export interface TitleProps extends Omit<TextProps, 'role' | 'as'> {
  /** Heading level (1-6). Defaults to 1. */
  order?: 1 | 2 | 3 | 4 | 5 | 6;
}

const ORDER_TO_ROLE = {
  1: 'title',
  2: 'headline',
  3: 'subtitle',
  4: 'subtitle',
  5: 'label',
  6: 'overline'
} as const;

/** Heading element bound to the design system's typography roles. */
export const Title = forwardRef(function Title(
  { order = 1, children, ...rest }: TitleProps,
  ref: Ref<HTMLElement>
): ReactNode {
  const Tag = `h${order}` as const;
  return (
    <Text ref={ref} as={Tag} role={ORDER_TO_ROLE[order]} {...rest}>
      {children}
    </Text>
  );
});
